<template>
    <div class="funfacts-box-content d-flex align-center justify-content-between">
        <div class="funfacts-box w-full position-relative transition-3s">
            <el-icon class="position-absolute"><User /></el-icon>
            <h1>100%</h1>
            <p>Positive Feedback</p>
        </div>
        <div class="funfacts-box w-full position-relative transition-3s">
            <el-icon class="position-absolute"><DataAnalysis /></el-icon>
            <h1>97%</h1>
            <p>Increase In Revenue</p>
        </div>
        <div class="funfacts-box w-full position-relative transition-3s">
            <el-icon class="position-absolute"><DataLine /></el-icon>
            <h1>800%</h1>
            <p>More Conversion</p>
        </div>
    </div>
</template>

<script>
import { DataLine, User, DataAnalysis } from '@element-plus/icons-vue'

export default {
    name: 'FunFactsBoxContent',
    components: {
        DataLine,
        User,
        DataAnalysis
    }
}
</script>